import { render, staticRenderFns } from "./importForm.vue?vue&type=template&id=46069e73&"
import script from "./importForm.vue?vue&type=script&lang=js&"
export * from "./importForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports